<route>
{
  "meta": {
    "permission": [
      "supplier.view_supplier"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <v-row row wrap>
      <v-col cols="12" md="3">
        <ValidationProvider
          vid="company_name"
          :name="$t('company_name')"
          v-slot="{ errors }"
        >
          <v-text-field
            color="secondary"
            outlined
            :error-messages="errors[0]"
            :label="$t('company_name')"
            v-model="form.company_name"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" md="3">
        <ValidationProvider
          vid="first_name"
          :name="$t('first_name')"
          v-slot="{ errors }"
        >
          <v-text-field
            color="secondary"
            outlined
            :error-messages="errors[0]"
            :label="$t('first_name')"
            v-model="form.first_name"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" md="3">
        <ValidationProvider
          vid="last_name"
          :name="$t('last_name')"
          v-slot="{ errors }"
        >
          <v-text-field
            color="secondary"
            outlined
            :error-messages="errors[0]"
            :label="$t('last_name')"
            v-model="form.last_name"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
    <i-table
      :title="$t('suppliersReport')"
      :headers="headers"
      app="supplier.supplier"
      api="supplier"
      :opt="{
        company_id: this.company.pk,
        company_name: this.form.company_name,
        first_name: this.form.first_name,
        last_name: this.form.last_name
      }"
      dontCreate
      dontRemove
      dontEdit
      dontSearch
    >
      <template v-slot:extraToolbar>
        <v-divider class="mx-4" inset vertical></v-divider>
        <i-btn
          text
          :small="$vuetify.breakpoint.smAndDown"
          icon="fa-file-excel"
          :title="$t('download', { value: $tc('supplier', 2) })"
          color="text-dark"
          @click="getSuppliersExcel()"
        >
        </i-btn>
        <i-btn
          text
          :small="$vuetify.breakpoint.smAndDown"
          icon="fa-file-pdf"
          :title="$t('download', { value: $tc('supplier', 2) })"
          color="text-dark"
          @click="getSuppliersPDF()"
        >
        </i-btn>
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      form: {
        company_name: '',
        first_name: '',
        last_name: ''
      }
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('company_name'),
          value: 'company_name'
        },
        {
          text: this.$t('first_name'),
          value: 'first_name'
        },
        {
          text: this.$t('last_name'),
          value: 'last_name'
        },
        {
          text: this.$tc('email', 1),
          value: 'email'
        },
        {
          text: this.$t('phone_number'),
          value: 'phone'
        }
      ]
    },
    ...mapGetters({
      company: 'company/getCompanyData'
    })
  },
  methods: {
    getSuppliersExcel() {
      this.downloadFile({
        api: 'supplier',
        method: 'excel',
        filename: 'Suppliers',
        action: 'download',
        ext: 'xlsx',
        opt: {
          pk: this.company.pk,
          params:
            '?company_name=' +
            this.form.company_name +
            '&first_name=' +
            this.form.first_name +
            '&last_name=' +
            this.form.last_name
        }
      })
    },
    getSuppliersPDF() {
      this.downloadFile({
        api: 'supplier',
        method: 'pdf',
        filename: 'Suppliers',
        action: 'download',
        ext: 'pdf',
        opt: {
          pk: this.company.pk,
          params:
            '?company_name=' +
            this.form.company_name +
            '&first_name=' +
            this.form.first_name +
            '&last_name=' +
            this.form.last_name
        }
      })
    }
  }
}
</script>
